import { render, staticRenderFns } from "./dsar-event-modal.vue?vue&type=template&id=282ec4a0&"
import script from "./dsar-event-modal.vue?vue&type=script&lang=js&"
export * from "./dsar-event-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports